var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jd-barchart-cont"},[_c('div',{ref:"barchart4",staticClass:"jd-barchart"}),_c('div',{ref:"barchart3",staticClass:"jd-barchart"}),_c('div',{ref:"barchart2",staticClass:"jd-barchart"}),_c('div',{ref:"barchart1",staticClass:"jd-barchart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }